import { useState } from "preact/hooks";
import { useLocalStorage } from "src/utils/hooks";
import { availableTimes } from "../rooms/callInfo";

const { DisplayOnce, Modal } = require("src/utils/fw");

function redirect(path) {
    location.href = location.pathname + "#" + path
}

const unregisteredModal = function({showSet = true, hash = null}) {
    const [show, setShow] = useState(showSet)
    const [lastHash, setHash] = useState(Date.now())

    if (hash && lastHash < hash) {
        setShow(showSet)
        setHash(hash)
    }

    this.showModal = () => setShow(true)

    return show ? 
        <Modal key="emptynetwork" id="emptynetwork" dismiss = {() => setShow(false)} dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                <h1>Thank you for stopping by the Networking Café! / Merci de vous être arrêté au café du réseautage!</h1>
                <hr />
                <p>The networking groups are reserved for those who pre-registered.<br/>
                    In the meantime, please check out the Freshly Brewed video with Jenny Tian. If you’d like to find out more about upcoming networking event opportunities, please email us at: GoFurtherWomen GoFurtherWomen@loblaw.ca
                </p>
                <p>Les groupes de réseautage sont réservés à ceux qui se sont déjà inscrits.<br/>
                    Entre-temps, veuillez regarder la vidéo fraîchement infusée avec Jenny Tian. Si vous souhaitez en savoir plus sur les occasions d’événements de réseautage à venir, veuillez nous envoyer un courriel à l’adresse : Voyez grand Femmes à Loblaw, GoFurtherWomen@loblaw.ca
                </p>
            </div>
        </Modal> : null
}

const registeredModal = () => <DisplayOnce key="joinnetwork" id="joinnetwork" dismissStyle={{ color: "white" }} dismissHTML="X" >
    <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
        <h1>Welcome to the 2022 International Women’s Day Summit brought to you by Go Further Women / Merci de vous être inscrit au Sommet de la Journée internationale des femmes 2022 organisé par Voyez grand Femmes à Loblaw</h1>
        <hr />
        <p>
            Welcome to the Networking Café! <br/>
            Our Café will be open for pre-registered networking from 1:00PM-4:00PM.<br/>
            Click on the back wall to join your live session.<br/>
            And while you’re here in the café, check out the Freshly Brewed video featuring Jenny Tian!<br/>
        </p>
        <p>
            Bienvenue au Café du réseautage!<br/>
            Notre café sera ouvert pour les activités de réseautage pré-enregistrées de 13 h à 16 h. Cliquez sur le mur de fond pour vous joindre à votre séance en direct.<br/>
            Pendant que vous êtes au café, regardez la vidéo fraîchement infusée mettant en vedette Jenny Tian!<br/>
        </p>
    </div>
</DisplayOnce>

export const Welcome = function({ triggerId =  null }) {
    const [show, setShow] = useState(false)
    const [elementTrigger, setElement] = useState(null)
    const [eventSet, setEventSet] = useState(false)

    if (triggerId && !elementTrigger) {
        let el = document.getElementById(triggerId)

        if (el) setElement(el)
        else {
            let int = setInterval(() => {
                let el = document.getElementById(triggerId)
                if (el) {
                    setElement(el)
                    clearInterval(int)
                }
            })      
        }
    }

    if (elementTrigger && !eventSet) {
        elementTrigger.addEventListener("click", () => {
            setShow(true)
        })
        setEventSet(true)
    }

    return show ? 
        <Modal key="welcome" id="welcome" dismiss = {() => setShow(false)} dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                <h1>Welcome! / Bienvenue!</h1>
                <p><strong>Welcome to the 2022 International Women's Day Summit brought to you by Go Further Women / Merci de vous être inscrit au Sommet de la Journée internationale des femmes 2022 organisé par Voyez grand Femmes à Loblaw</strong></p>
                <hr />
                <p>Make sure you visit the "Activity Lounge" throughout the day to learn about and participate in our activites including our Scavenger Hunt and Trivia games. There's also a Selfie booth for taking photos and sharing. Enjoy your day and make the most of it! #BreakTheBias #IWD2022 #GFW</p>
                <p>N’oubliez pas de visiter le « salon d’activités » tout au long de la journée pour en apprendre davantage sur nos activités et y participer, notamment notre chasse au trésor et nos jeux-questionnaires. Il y a aussi une cabine pour égoportraits pour prendre des photos et les partager. Passez une belle journée et profitez-en au maximum! #Brisonslespréjugés #JIDF2022 #VGF</p>
            </div>
        </Modal> : null
}

export const Mosaic = function({ triggerId =  null }) {
    const [show, setShow] = useState(false)
    const [elementTrigger, setElement] = useState(null)
    const [eventSet, setEventSet] = useState(false)

    if (triggerId && !elementTrigger) {
        let el = document.getElementById(triggerId)

        if (el) setElement(el)
        else {
            let int = setInterval(() => {
                let el = document.getElementById(triggerId)
                if (el) {
                    setElement(el)
                    clearInterval(int)
                }
            })
        }
    }

    if (elementTrigger && !eventSet) {
        elementTrigger.addEventListener("click", () => {
            setShow(true)
        })
        setEventSet(true)
    }

    return show ? 
        <Modal key="mosaic" id="mosaic" dismiss = {() => setShow(false)} dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                <iframe style = {{width: "56em", height: "60vh"}} src = "https://my.guest.camera/mosaic/2022IWDS"/>
            </div>
        </Modal> : null
}

export const SelfieGallery = function({ triggerId =  null }) {
    const [show, setShow] = useState(false)
    const [elementTrigger, setElement] = useState(null)
    const [eventSet, setEventSet] = useState(false)

    if (triggerId && !elementTrigger) {
        let el = document.getElementById(triggerId)

        if (el) setElement(el)
        else {
            let int = setInterval(() => {
                let el = document.getElementById(triggerId)
                if (el) {
                    setElement(el)
                    clearInterval(int)
                }
            })
        }
    }

    if (elementTrigger && !eventSet) {
        elementTrigger.addEventListener("click", () => {
            setShow(true)
        })
        setEventSet(true)
    }

    return show ? 
        <Modal key="selfieGallery" id="selfieGallery" dismiss = {() => setShow(false)} dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                <iframe style = {{width: "56em", height: "60vh"}} src = "https://my.guest.camera/mosaic/2022IWDS"/>
            </div>
        </Modal> : null
}


export const TriviaModal = function() {
    const [show, setShow] = useState(false)

    this.showModal = () => {
        setShow(true)
    }

    return show ? 
        <Modal key="triviamodal" id="triviamodal" dismiss = {() => setShow(false)} dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                <h1>Welcome to Trivia!  / Bienvenue au jeu-questionnaire!</h1>
                <p><strong>Test your knowledge for a chance to win a prize! / Testez vos connaissances pour courir la chance de gagner un prix!</strong></p>
                <hr />
                <p>You will have 20 seconds to respond to each question. Your score is calculated based on how quickly you select the correct response. Don’t forget to check out the leaderboard to see how you score!</p>
                <p>Only ONE play per participant. Contest will remain open until the platform closes at 6 pm.</p>
                <p>Prize for first place: iPad, Prize for second place: Nintendo Switch Console, prize for third place $75 PC Points, prize for fourth place $50 PC points, prize for fifth place $25 PC points. Also, all participants will be entered into a draw for a chance to win $50 in PC Points!</p>
                <p><b>Good luck!</b></p>
                <p>Please enter the same contact information used during registration.</p>
                <p><a style = {{color: "#fff"}} href = "https://assets.swoogo.com/uploads/1628405-622154ca208d6.pdf">Link to official contest rules &amp; regulations</a></p>
                <p><a style = {{color: "#fff", "font-weight": "bold"}} href = "" onClick = {(e) => {
                    e.preventDefault()
                    document.getElementById("trivia-eng").click()
                    setShow(false)
                }} >English</a></p>
                <hr/>
                <p>Vous aurez 20 secondes pour répondre à chaque question. Votre score est calculé en fonction de la rapidité avec laquelle vous sélectionnez la bonne réponse. N'oubliez pas de consulter le classement pour connaître votre score!</p>
                <p>UN seul jeu par participant. Le concours restera ouvert jusqu'à la fermeture de la plateforme à 18 heures.</p>
                <p>Prix pour la première place : iPad; prix pour la deuxième place : Nintendo Switch Console ; prix pour la troisième place : 75 $ en points PC; prix pour la quatrième place : 50 $ en points PC; prix pour la cinquième place : 25 $ en points PC. De plus, tous les participants seront inscrits à un tirage pour courir la chance de gagner 50 $ en points PC!</p>
                <p><b>Bonne chance!</b></p>
                <p>Veuillez saisir les mêmes informations de contact que celles utilisées lors de l'inscription.</p>
                <p><a style = {{color: "#fff"}} href = "https://assets.swoogo.com/uploads/1633427-62263496d7354.pdf">Règlement officiel du concours</a></p>
                <p><a style = {{color: "#fff", "font-weight": "bold"}} href = "" onClick = {(e) => {
                    e.preventDefault()
                    document.getElementById("trivia-french").click()
                    setShow(false)
                }} >Français</a></p>
            </div>
        </Modal> : null
}

export const DisplayOnceTrigger = ({id, triggerId, href, callback, children}) => {
    const [isDisplayed, setIsDisplayed] = useLocalStorage(`displayOnce-${id}`)
    const [show, setShow] = useState(false)
    const [elementTrigger, setElement] = useState(null)
    const [eventSet, setEventSet] = useState(false)

    if (triggerId && !elementTrigger) {
        let el = document.getElementById(triggerId)

        if (el) setElement(el)
        else {
            let int = setInterval(() => {
                let el = document.getElementById(triggerId)
                if (el) {
                    setElement(el)
                    clearInterval(int)
                }
            })
        }
    }

    if (elementTrigger && !eventSet) {
        elementTrigger.addEventListener("click", () => {
            if (isDisplayed) {
                if (callback) callback()
                if (href !== null) redirect(href)
            }
            setShow(true)
        })

        setEventSet(true)
    }

    const close = () => {
        setShow(false)
        setIsDisplayed(true)
        if (callback) callback()
        if (href !== null) redirect(href)
    }

    return !isDisplayed && show ? 
        <Modal key="id" id="id" dismiss = { close } dismissStyle={{ color: "white" }} dismissHTML="X" >
            <div style={{ background: "#862c91", borderRadius: "10px", color: "white", textAlign: "center", maxWidth: "60em", padding: "2em" }}>
                { children }
            </div>
        </Modal> : null
}

export const ClueModal = ({id, href = null, callback = null, triggerId, clueEng, clueFra} = {}) => {
    return <DisplayOnceTrigger {...{id, href, triggerId, callback}}>
        <h1>Congratulations! You found a word clue / Félicitations! Vous avez trouvé un mot indice</h1>
        <hr />
        <p><b>Clue: {clueEng}</b></p>
        <p>Write down this clue to unscramble a phrase</p>
        <p>To learn more about the Scavenger Hunt, visit the <a href = "#" onClick = { () => redirect("/activity-lounge") }>Activity Lounge.</a></p>
        <hr/>
        <p><b>Indice: {clueFra}</b></p>
        <p>Écrivez cet indice pour déchiffrer une phrase.</p>
        <p>Pour en savoir plus sur la chasse au trésor, visitez le <a href = "#" onClick = { () => redirect("/activity-lounge") }>salon d’activités.</a></p>
    </DisplayOnceTrigger>
}

export const MainClue = ({href = "/main-stage", triggerId = "Main Stage"} = {}) => {
    return <DisplayOnceTrigger id = "triviaclue" {...{href, triggerId}}>
        <h1>Congratulations! You found a word clue / Félicitations! Vous avez trouvé un mot indice</h1>
        <hr />
        <p><b>Clue: will</b></p>
        <p>Write down this clue to unscramble a phrase</p>
        <p>To learn more about the Scavenger Hunt, visit the <a href = "#" onClick = { () => redirect("/activity-lounge") }>Activity Lounge.</a></p>
        <hr/>
        <p><b>Indice: vais</b></p>
        <p>Écrivez cet indice pour déchiffrer une phrase.</p>
        <p>Pour en savoir plus sur la chasse au trésor, visitez le <a href = "#" onClick = { () => redirect("/activity-lounge") }>salon d’activités.</a></p>
    </DisplayOnceTrigger>
}

export const GroupModal = availableTimes.haveAny ? registeredModal : unregisteredModal